import { render } from "./ProfileList.vue?vue&type=template&id=3028a72b&scoped=true"
import script from "./ProfileList.vue?vue&type=script&lang=js"
export * from "./ProfileList.vue?vue&type=script&lang=js"

import "./ProfileList.vue?vue&type=style&index=0&id=3028a72b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3028a72b"]])

export default __exports__